import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';
import { createLocale } from '../../utils.js';

const locales = {
  en: createLocale(en, 'company'),
  uk: createLocale(uk, 'company'),
  pl: createLocale(pl, 'company'),
  ru: createLocale(ru, 'company'),
  es: createLocale(es, 'company'),
  uz: createLocale(uz, 'company'),
  hi: createLocale(hi, 'company'),
};

export default locales;
